import { render, staticRenderFns } from "./SPQUploadAdminDashboard.vue?vue&type=template&id=d7fbf8ce&"
import script from "./SPQUploadAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./SPQUploadAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports